import { Black, Blue, Gray, White } from "./client-color";

// 主题色
const Theme = {
  "theme-1": White["white-10"],
};

// 字体色
const ColorText = {
  "color-text-1": Blue["blue-2"],
  "color-text-2": Blue["blue-4"],
  "color-text-3": Blue["blue-1"],
  "color-text-4": Blue["blue-9"],
  "color-text-5": Blue["blue-6"],
  "color-text-6": Blue["blue-11"],
  "color-text-7": Blue["blue-5"],
  "color-text-8": Blue["blue-3"],
  "color-text-9": Blue["blue-4"],
};

// 填充色
const ColorFill = {
  "color-fill-1": White["white-7"],
  "color-fill-2": White["white-8"],
  "color-fill-3": White["white-4"],
  "color-fill-4": White["white-6"],
  "color-fill-5": White["white-1"],
  "color-fill-6": White["white-9"],
  "color-fill-7": White["white-5"],
  "color-fill-8": Gray["gray-1"],
  "color-fill-9": Blue["blue-5"],
  "color-fill-10": Blue["blue-11"],
  "color-fill-11": Blue["blue-12"],
  "color-fill-12": White["white-3"],
  "color-fill-13": Blue["blue-11"],
};

// 描边色
const ColorLine = {
  "color-line-1": White["white-2"],
  "color-line-2": White["white-3"],
};

// 渐变
const ColorGradient = {
  "gradient-fill-1":
    "linear-gradient(180deg, #FFFFFF -20.31%, #D5EDFF 86.8%, #AAD1FF 151.58%)",
  "gradient-fill-2":
    "linear-gradient(134.82deg, #2d81ff 21.18%, #2558ff 95.87%)",
  "gradient-fill-3": "rgba(255, 255, 255, 0.9)",
  "gradient-fill-4":
    "linear-gradient(180deg, #DCEDFE 0%, rgba(242, 249, 255, 0.25) 100%)",
  "gradient-fill-5": "linear-gradient(0deg, #FFFFFF 20.45%, #BFD5FF 166.73%)",
  "gradient-fill-6":
    "linear-gradient(134.82deg, #2D81FF 21.18%, #2558FF 95.87%)",
  "gradient-fill-7":
    "linear-gradient(0deg, rgba(61, 114, 235, 0.02) 0%, rgba(61, 114, 235, 0.2) 100%)",
};

// 阴影
const ColorShadow = {
  "shadow-1": "0px 2px 19px 0px rgba(154, 195, 226, 0.39)",
  "shadow-2": "0px -2px 8px 2px rgba(180, 206, 255, 0.3) inset",
};

export default {
  ...Theme,
  ...ColorText,
  ...ColorFill,
  ...ColorLine,
  ...ColorGradient,
  ...ColorShadow,
};
